import { Link, useLocation, useNavigate } from "react-router";
import { useState, useEffect } from "react";
import "./Header.css";

function Header() {

    const nowpage = useLocation();
    const navigate = useNavigate();

    const isLogin = localStorage.getItem("로그인현황") === "true";

    const [logoutModalOpen, setLogoutModalOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);

    // 로그아웃 버튼 클릭 → 모달만 열기
    const handleLogout = () => {
        setLogoutModalOpen(true);
    };

    // 로그아웃 확인
    const confirmLogout = () => {
        const accountInfo = {
            nickname: "",
            name: "",
            mailAdress: "",
            phoneNumber: "",
            birthday: "",
            id: "",
            pw: "",
        };

        localStorage.setItem("계정정보", JSON.stringify(accountInfo));
        localStorage.setItem("로그인현황", "false");

        setLogoutModalOpen(false);
        navigate("/");
        window.scrollTo(0, 0);
    };

    // 스크롤 헤더 효과
    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 50);
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <>
            {/* ================= HEADER ================= */}
            <header className={`header ${scrolled ? "scrolled" : ""}`}>
                <div className="container d-flex justify-content-between align-items-center">

                    {/* LOGO */}
                    <Link
                        to="/"
                        className="header-logo"
                        onClick={() => window.scrollTo(0, 0)}
                    >
                        <img
                            src="/images/common/OpenPlaceHorizontal.png"
                            alt="OpenPlace Logo"
                            className="logo-icon"
                        />
                    </Link>

                    {/* NAV */}
                    <nav>
                        <ul className="d-flex gap-4 mb-0">
                            <li>
                                <button className="header-button-find">
                                    <i className="header-image-find" onClick={()=>
                                        navigate(`/search?query=${encodeURIComponent('')}`)
                                    }/>
                                </button>
                            </li>
                            <li>
                                <Link
                                    to="/funding/main/1"
                                    className="nav-link"
                                    onClick={() => window.scrollTo(0, 0)}
                                >
                                    Funding
                                </Link>
                            </li>

                            <li>
                                <Link
                                    to="/community/main/1"
                                    className="nav-link"
                                    onClick={() => window.scrollTo(0, 0)}
                                >
                                    Community
                                </Link>
                            </li>

                            <li>
                                <Link
                                    to="/about"
                                    className="nav-link"
                                    onClick={() => window.scrollTo(0, 0)}
                                >
                                    About
                                </Link>
                            </li>

                            {isLogin ? (
                                <>
                                    <li>
                                        <Link
                                            to="/mypage"
                                            className="nav-link"
                                            onClick={() => window.scrollTo(0, 0)}
                                        >
                                            MyPage
                                        </Link>
                                    </li>
                                    <li>
                                        <button
                                            className="nav-link logout-btn"
                                            onClick={handleLogout}
                                        >
                                            Logout
                                        </button>
                                    </li>
                                </>
                            ) : (
                                <li
                                    onClick={() => {
                                        localStorage.setItem(
                                            "마지막 주소",
                                            JSON.stringify(nowpage.pathname)
                                        );
                                    }}
                                >
                                    <Link
                                        to="/login"
                                        className="nav-link"
                                        onClick={() => window.scrollTo(0, 0)}
                                    >
                                        Log-In
                                    </Link>
                                </li>
                            )}
                        </ul>
                    </nav>
                </div>
            </header>

            {/* ================= LOGOUT MODAL ================= */}
            {logoutModalOpen && (
                <div className="logout-modal-backdrop">
                    <div className="logout-modal-box">
                        <p className="logout-modal-text">
                            로그아웃 하시겠습니까?
                        </p>

                        <div className="logout-modal-btn-group">
                            <button
                                className="logout-modal-confirm-btn"
                                onClick={confirmLogout}
                            >
                                확인
                            </button>
                            <button
                                className="logout-modal-cancel-btn"
                                onClick={() => setLogoutModalOpen(false)}
                            >
                                취소
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default Header;
